import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { raygunHttpError } from '@approot/app.raygun.setup';
import { AlertsService, AuthService } from '@approot/services';
import { Observable, throwError, catchError } from 'rxjs';
import { CreditLine } from './credit-line.interface';

@Injectable({
  providedIn: 'root'
})
export class CreditLinesService {
  constructor(
    private alertsService: AlertsService,
    private authService: AuthService
  ) {}

  public getCreditLines(): Observable<CreditLine[]> {
    return this.getUserInfo<any>({
      task: 'getCreditLines'
    });
  }

  public setCreditLines(items: any): Observable<{}> {
    return this.getUserInfo<any>({
      task: 'setCreditLines',
      items
    });
  }

  private handleError(error: HttpErrorResponse) {
    this.alertsService.addHttpAlert({ error });
    return throwError(
      () => new Error('Something bad happened; please try again later.')
    );
  }

  private getUserInfo<T>(params: Record<string, string>): Observable<T> {
    const httpParams = new HttpParams().appendAll(params).toString();
    return this.authService.fxPost<T>(params, `get-user-info`, httpParams).pipe(
      catchError(err => {
        raygunHttpError(err, ['get-user-info']);
        return this.handleError(err);
      })
    );
  }
}
